export const getProductSpecificationsStub = () => {
  return null;
  return [
    { name: "Width", value: "22", type: "length" },
    { name: "Height", value: "22", type: "length" },
    { name: "Weight", value: "22", type: "weight" },
    { name: "Material", value: "22", type: "text" },
  ];
};
